(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('jquery'));
    } else {
        factory(window.jQuery);
    }
}(function ($) {
    tinymce.PluginManager.add('tags', function (editor, url) {
        editor.ui.registry.addButton('tags', {
            // text: 'Tags',
            tooltip: 'Tags',
            icon: 'code-sample',
            onAction: function () {
                $.ajax({
                    type: 'get',
                    url: '/communication/tags',
                    data: {'tags_dossier': $('.tags_dossier').val()},
                    dataType: 'json',
                    cache: false,
                    success: function (response) {
                        let content = '<table class="tinymce-list-tags" style="font-size: 14px;"><thead><tr><th class="center-align">Nom</th><th>Infos</th></tr></thead><tbody>';
                        for (const key in response) {
                            content += '<tr><td style="padding: 6px 0;"><label class="margin-r-10"><input type="checkbox" id="tag-' + key + '" class="tag filled-in" value="[' + key + ']"/><span>[' + key + ']</span></label></td><td>' + response[key] + '</td></tr>';
                        }
                        content += '</tbody></table>';

                        editor.windowManager.open({
                            title: 'Insérer des tags',
                            body: {
                                type: 'panel',
                                items: [
                                    {
                                        type: 'htmlpanel',
                                        html: content
                                    }
                                ]
                            },
                            buttons: [
                                {
                                    type: 'cancel',
                                    text: 'Annuler'
                                },
                                {
                                    type: 'submit',
                                    text: 'Insérer'
                                }
                            ],
                            size: 'medium',
                            onSubmit: function (api) {
                                $('.tinymce-list-tags .tag:checked').each(function () {
                                    editor.insertContent($(this).val());
                                });

                                api.close();
                            }
                        });

                        if ($('.tinymce-list-tags').length > 0) {
                            $('.tinymce-list-tags').dataTable({
                                language: {
                                    url: "/js/datatables/translations/fr.json"
                                },
                                deferRender: true,
                                stateSave: true,
                                retrieve: true,
                                aLengthMenu: [[10, 25, 100, -1], [10, 25, 100, "Tous"]],
                                responsive: true,
                                pageLength: 10
                            });
                        }
                    }
                });
            }
        });

        return {
            getMetadata: function () {
                return {
                    name: 'Insérer des tags',
                };
            }
        };
    });
}));
